export default [
  {
    path: "/msgraph-config",
    name: "MsGraphConfig",
    component: () => import("@/views/Page/MsGraphConfig/MsGraphConfig.vue"),
    meta: {
      title: "Microsoft Graph Config",
      requiresAuth: true,
    },
  },
];
